import { ComponentPropsWithoutRef } from "react";

import cn from "lib/cn";

export type TSkeletonVariant = "gray" | "white";

export type SkeletonProps = ComponentPropsWithoutRef<"div">;

export default function Skeleton({
  className,
  style,
  id,
  ...rest
}: SkeletonProps) {
  return (
    <div
      id={id}
      data-testid={id}
      className={cn("animate-shimmer bg-gray-5", className)}
      style={{
        backgroundImage:
          "linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)",
        backgroundSize: "2000px 100%",
        backgroundRepeat: "no-repeat",
        ...style,
      }}
      {...rest}
    />
  );
}
